import React from 'react';
import Info from './Info';

function InfoContainer({prevStep, nextStep}) {
    return (
        <div>
            <Info prevStep={prevStep} nextStep={nextStep} />
        </div>
    );
}

export default InfoContainer;